<template>
  <div style="margin-top: -30px; margin-bottom: 20px">
    <b-row>
      <b-col>
        <InfoMediaAvailable :available-to="mediaAvailableTo" :last-stay-deletion-date="lastStayDeletionDate"
                            v-if="mediaAvailableTo"/>
        <InfoSdHdAvailable :hd-available-to="hdAvailableTo"
                         v-else-if="hdAvailableTo"/>
        <InfoMediaDeleted v-else-if="mediaDeleted"/>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import InfoMediaDeleted from "@/domain/checkin/components/mediaInfo/InfoMediaDeleted.vue";
import InfoMediaAvailable from "@/domain/checkin/components/mediaInfo/InfoMediaAvailable.vue";
import {mapGetters} from "vuex";
import InfoSdHdAvailable from "@/domain/checkin/components/mediaInfo/InfoSdHdAvailable.vue";

export default {
  name: "InfosMedia",
  components: {InfoSdHdAvailable, InfoMediaAvailable, InfoMediaDeleted},
  computed: {
    ...mapGetters('checkinDetail', [
      'hdAvailableTo',
      'mediaAvailableTo',
      'mediaDeleted',
      'lastStayDeletionDate']),
  },

}
</script>

<style scoped>

</style>